import React from "react";
import PropTypes from "prop-types";
import "./TransactionTable.css";

function TransactionTable({ transactions }) {
  if (!transactions || transactions.length === 0) {
    return <div className="transaction-table-empty">No transactions found.</div>;
  }
  return (
    <div className="transaction-table-container">
      <table className="transaction-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Amount (RM)</th>
            <th>Raw Match</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((txn, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{txn.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
              <td>{txn.raw}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

TransactionTable.propTypes = {
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      raw: PropTypes.string.isRequired
    })
  ).isRequired
};

export default TransactionTable;
